import {createContext, useContext, useEffect, useState} from "react";
import {collection, getDocs} from "firebase/firestore/lite";
import {db} from "../firebase"

const MenuContext = createContext();

export const MenuItemsContextProvider = ({children}) => {

	const [getItem, setItem] = useState()

	async function getMenu(db)
	{
		const menuCollection = collection(db, 'menuItems')
		const menuSnapshot = await getDocs(menuCollection);
		const list = menuSnapshot.docs.map(doc => doc.data())
		setItem(list)
		return list
	}
	useEffect(()=>{
		getMenu(db)
	}, [])

	return(
		<MenuContext.Provider value={[{getItem}]}>
			{children}
		</MenuContext.Provider>
	)

}

export const UseMenu = () => {
	return useContext(MenuContext)
}